<template>
    <label class="switch" :class="{disabled: isDisabled, middle: isMiddle}" :title="title" @click.stop="handler">
        <span class="switch__dots" @click.stop="handlerOff"></span>
        <span class="switch__dots"></span>
        <span class="switch__dots" @click.stop="handlerOn"></span>
        <input
            type="checkbox"
            :checked="checked"
            :disabled="isCanToggle"
            @change="$emit('change', $event.target.checked)"
        />
        <span class="slider"></span>
    </label>
</template>

<script>
export default {
    name: "ToggleButtonWithMiddle",
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        checked: false,
        callback: null,
        isMiddle: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    computed: {
        isCanToggle() {
            return this.isDisabled || !!this.callback;
        }
    },
    methods: {
        handler() {
            if (this.isDisabled || this.isMiddle) {
                return;
            }

            if (this.callback) {
                this.callback(!this.checked);
            }
        },
        handlerOn() {
            if (this.isDisabled || (this.checked && !this.isMiddle)) {
                return;
            }

            if (this.callback) {
                this.callback(true);
            } else {
                this.checked = true;
            }
        },
        handlerOff() {
            if (this.isDisabled || (!this.checked && !this.isMiddle)) {
                return;
            }

            if (this.callback) {
                this.callback(false);
            } else {
                this.checked = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 18px;
    cursor: pointer;
    /* Hide default HTML checkbox */
    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    &__dots {
        display: block;
        position: absolute;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        top: 1px;
        left: 1px;
        z-index: 1;
        //opacity: 0.2;
        &:after {
            content: '';
            display: block;
            position: absolute;
            top: 6px;
            left: 6px;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: white;
            opacity: 0.2;
        }
        &:nth-child(2) {
            left: 14px;
        }
        &:nth-child(3) {
            left: 27px;
        }
    }

    &.disabled {
        cursor: not-allowed;

        input + .slider {
            background-color: $grey;
        }
    }

    input:checked + .slider {
        background-color: $tests-blue;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $tests-blue;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
    }

    &.middle {
        input + .slider {
            background-color: $tests-blue;
        }

        input + .slider:before {
            -webkit-transform: translateX(13px);
            -ms-transform: translateX(13px);
            transform: translateX(13px);
        }
    }

    /* The slider */
    .slider {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $grey;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 16px;

        &::before {
            position: absolute;
            content: "";
            height: 12px;
            width: 12px;
            left: 3px;
            bottom: 3px;
            border-radius: 50%;
            background-color: $white;
            -webkit-transition: .4s;
            transition: .4s;
            z-index: 2;
        }
    }
}
</style>